import { v4 as uuidv4 } from "uuid";

export function generateId(key: string | number): string {
  return `${key}-${uuidv4()}`;
}
